module.exports = __webpack_public_path__ + "230955aa5c0d83a6bf219e69a11ef0b0.svg";